import React, { useState, useEffect } from "react";
import "./MobileScaleWrapper.css";

const DESKTOP_WIDTH = 1200;
const DESKTOP_HEIGHT = 675;
const MOBILE_BREAKPOINT = 768;

const MobileScaleWrapper = ({
  children,
  gradientTop = "#ff9a9e",
  gradientBottom = "#fecfef",
  scrollable = false,
}) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );
  const [scale, setScale] = useState(window.innerWidth / DESKTOP_WIDTH);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsMobile(w <= MOBILE_BREAKPOINT);
      setScale(w / DESKTOP_WIDTH);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isMobile) return <>{children}</>;

  return (
    <div
      className="mobile-scale-bg"
      style={{
        background: `linear-gradient(180deg, ${gradientTop} 0%, ${gradientBottom} 100%)`,
      }}
    >
      <div
        className="mobile-scale-content"
        style={{
          width: DESKTOP_WIDTH,
          height: DESKTOP_HEIGHT,
          transform: `scale(${scale})`,
          overflowY: scrollable ? "auto" : "hidden",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MobileScaleWrapper;
